// Activity types for workouts logged without Apple Health, and the muscles they usually load
// (same suggestions as RecoverCore ActivityCatalog).
import { activityLabel } from '../../../supabase/functions/_shared/digest.ts';
import type { SelectedMuscle } from './selection.ts';

export { activityLabel };

export const SOLO_ACTIVITIES = ['running', 'cycling', 'swimming', 'walking', 'hiking', 'rowing', 'strength', 'hiit', 'yoga', 'pilates', 'other'];

const SUGGESTIONS: Record<string, string[]> = {
  running: ['quads.rectus_femoris', 'quads.vastus_lateralis', 'quads.vastus_medialis', 'hamstrings.biceps_femoris',
    'calves.gastroc_medial', 'calves.gastroc_lateral', 'calves.soleus', 'glutes.glute_max'],
  walking: ['calves.gastroc_medial', 'calves.gastroc_lateral', 'calves.soleus', 'glutes.glute_max'],
  hiking: ['quads.rectus_femoris', 'quads.vastus_lateralis', 'glutes.glute_max', 'calves.soleus', 'calves.gastroc_medial'],
  cycling: ['quads.rectus_femoris', 'quads.vastus_lateralis', 'quads.vastus_medialis', 'glutes.glute_max', 'calves.soleus'],
  swimming: ['back.lats', 'shoulders.delt_front', 'shoulders.delt_side', 'triceps.long_head', 'core.abs'],
  rowing: ['back.lats', 'back.traps_mid', 'biceps.long_head', 'biceps.short_head', 'quads.rectus_femoris', 'hamstrings.biceps_femoris'],
  yoga: ['core.abs', 'core.obliques', 'hamstrings.biceps_femoris'],
  pilates: ['core.abs', 'core.obliques', 'glutes.glute_med'],
};

export function suggestedMuscles(activity: string): SelectedMuscle[] {
  return (SUGGESTIONS[activity] ?? []).map((muscle_id) => ({ muscle_id, selection: 'specific' }));
}
